import React, { useState } from "react";
import "../styles/MailDashboard.css";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function MailDashboard() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null); // null | "loading" | "success" | "error"
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = email.trim().toLowerCase();

    if (!trimmed || !EMAIL_RE.test(trimmed)) {
      setStatus("error");
      setMessage("Please enter a valid email address.");
      return;
    }

    setStatus("loading");
    setMessage("");

    try {
      const res = await fetch("/api/send-dashboard", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: trimmed }),
      });

      const data = await res.json();

      if (res.ok && data.success) {
        setStatus("success");
        setMessage("Dashboard sent! Check your inbox (and spam folder).");
        setEmail("");
      } else {
        setStatus("error");
        setMessage(data.error || "Something went wrong. Please try again.");
      }
    } catch {
      setStatus("error");
      setMessage("Network error. Please try again later.");
    }
  };

  return (
    <section className="mail-dashboard-section" id="mail-dashboard">
      <div className="mail-dashboard-wrapper">
        <h2 className="section-title">Receive Test In-Mail Dashboard</h2>
        <p className="mail-dashboard-intro">
          Enter your email to receive a sample Mobile Sales interactive dashboard report
          directly in your inbox — charts, tables, and KPIs, all rendered
          inside the email itself. No attachments, no links.
        </p>

        <div className="mail-dashboard-card">
          <form className="mail-dashboard-form" onSubmit={handleSubmit}>
            <div className="mail-dashboard-input-group">
              <input
                type="email"
                className={`mail-dashboard-input${status === "error" && !email.trim() ? " input-error" : ""}`}
                placeholder="you@example.com"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (status === "error") setStatus(null);
                }}
                disabled={status === "loading"}
                autoComplete="email"
                required
              />
            </div>
            <button
              type="submit"
              className="mail-dashboard-submit"
              disabled={status === "loading"}
            >
              {status === "loading" ? (
                <>
                  <span className="spinner" />
                  Sending…
                </>
              ) : (
                "Send Dashboard"
              )}
            </button>
          </form>

          {status && status !== "loading" && (
            <div className={`mail-dashboard-message ${status}`}>
              {message}
            </div>
          )}

          <p className="mail-dashboard-note">
            Your email is only used to deliver this one-time demo report.
          </p>
        </div>
      </div>
    </section>
  );
}
